export const NewTestForm = `flex flex-col gap-6 justify-center`
